import { render, staticRenderFns } from "./vAlertMsg.vue?vue&type=template&id=79750700&scoped=true"
import script from "./vAlertMsg.vue?vue&type=script&lang=ts"
export * from "./vAlertMsg.vue?vue&type=script&lang=ts"
import style0 from "./vAlertMsg.vue?vue&type=style&index=0&id=79750700&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79750700",
  null
  
)

export default component.exports